var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1839 11.836L13.1276 2.78443L12.5206 2.1774C12.3823 2.04 12.1952 1.96289 12.0003 1.96289C11.8053 1.96289 11.6183 2.04 11.48 2.1774L1.8167 11.836C1.67497 11.9772 1.56297 12.1453 1.48729 12.3305C1.41161 12.5156 1.3738 12.7141 1.37607 12.9141C1.38545 13.7391 2.07217 14.3977 2.89717 14.3977H3.89326V22.0313H20.1073V14.3977H21.1245C21.5253 14.3977 21.9026 14.2407 22.1862 13.9571C22.3259 13.8179 22.4365 13.6524 22.5117 13.4701C22.587 13.2879 22.6253 13.0925 22.6245 12.8954C22.6245 12.4969 22.4675 12.1196 22.1839 11.836V11.836ZM13.3128 20.3438H10.6878V15.5626H13.3128V20.3438ZM18.4198 12.7102V20.3438H14.8128V15.0001C14.8128 14.4821 14.3933 14.0626 13.8753 14.0626H10.1253C9.60732 14.0626 9.18779 14.4821 9.18779 15.0001V20.3438H5.58076V12.7102H3.33076L12.0026 4.04537L12.544 4.58678L20.6722 12.7102H18.4198Z",
    fill: "#00CCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.6d7aebb58379098a06f03aeb89490134.svg";
export { ForwardRef as ReactComponent };